import React, { useState,useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { API } from 'javascripts/api'
import ClientMonthlyWorkReportDetailHeader from 'spa/client/components/ClientMonthlyWorkReportDetailHeader'
import ClientMonthlyWorkReportDetailSheet from 'spa/client/components/ClientMonthlyWorkReportDetailSheet'
import ClientLayout from 'spa/client/layouts/ClientLayout'
import ErrorPage from 'spa/client/pages/ErrorPage'
import { MonthlyWorkReportDetail } from 'javascripts/api/generated'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

const ClientMonthlyWorkReportDetail: React.FC = () => {

  const location = useLocation()
  const navigate = useNavigate()
  const { monthlyWorkReportId } = useParams<{ monthlyWorkReportId: string }>()

  const [monthlyWorkReportDetail, setMonthlyWorkReportDetail] = useState<MonthlyWorkReportDetail | null>(null)
  const [notFound, setNotFound] = useState<boolean>(false)

  const fetchMonthlyWorkReportDetail = async (id: number) => {
    try {
      const response = await API.getClientMonthlyWorkReport(id)
      setNotFound(false)
      setMonthlyWorkReportDetail(response.data)
    } catch (error) {
      if (API.isAxiosError(error)) {
        if (error.response && error.response.status === 401) {
          navigate('/client_auth/login', {
            state: {
              flash: { error: 'ログインしてください。' },
              backTo: location.pathname,
            },
          })
        } else if (error.response && error.response.status === 403) {
          navigate('/clients/monthly_work_reports', {
            state: {
              flash: { error: 'アクセス権限がありません。' }
            },
          })
        } else if (error.response && error.response.status === 404) {
          setNotFound(true)
        }
      }
    }
  }

  const initializeComponent = () => {
    const numMonthlyWorkReportId = Number(monthlyWorkReportId)
    if (isNaN(numMonthlyWorkReportId)) {
      return
    }

   void fetchMonthlyWorkReportDetail(numMonthlyWorkReportId)
  }

  useEffect(() => {
    initializeComponent()
  }, []) // 初回レンダリング時のみ実行

  if (notFound) return <ErrorPage />

  if (!monthlyWorkReportDetail) return <div styleName='loading-text'>Loading...</div> // データがまだフェッチされていない場合のローディング表示

  return (
    <ClientLayout>
      <div styleName='work-report'>
        <ClientMonthlyWorkReportDetailHeader monthlyWorkReport={monthlyWorkReportDetail} />
        <ClientMonthlyWorkReportDetailSheet monthlyWorkReport={monthlyWorkReportDetail} />
      </div>
    </ClientLayout>
  )
}
  export default CSSModules(ClientMonthlyWorkReportDetail, styles)
